<div class="row">
  <div class="col-sm-12 mb-2">
    <span class="mr-2" style="display: inline-block;">*</span><h2 class="text-primary mt-3" style="display: inline-block;">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Title' | translate}}</h2>
  </div>
</div>

<!--Pensão de sobrevivência -->
<div class="row">
  <div class="col-sm-12 ml-2">
    <div class="form-check mb-4">
      <input class="form-check-input"
             aria-controls="collapseManual"
             type="checkbox"
             [(ngModel)]="cardData.survivalPensionBenefit"
             name="survivalPensionBenefit"
             #survivalPensionBenefit="ngModel"
             id="PensaoSobreviviencia"
             disabled
             (change)="isSurvivalPensionBenefitChanged($event.target.checked)"
             [checked]="cardData?.survivalPensionBenefit?.toString()=='true'">
      <label class="form-check-label align-items-center " for="PensaoSobreviviencia">
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.SurvivalPensionBenefit' | translate}}
        <span class="text-primary ml-1" aria-label="Tooltip com informação" [ngClass]="isVisibleSurvivalPensionBenefit ? 'icon-minus' : 'icon-more'" (click)="toggleVisibilitySurvivalPensionBenefit()"></span>
      </label>
      <div class="pt-2 text-gray-600 mt-2 mb-5" *ngIf="isVisibleSurvivalPensionBenefit" style="text-align: justify;">
        <br />
        <span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.SurvivalPensionBenefitTooltip' | translate}}</span>
      </div>
    </div>
  </div>
</div>

<!--Reembolso de despesas de funeral -->
<div class="row">
  <div class="col-sm-12 ml-2">
    <div class="form-check mb-4">
      <input class="form-check-input"
             aria-controls="collapseManual"
             type="checkbox"
             [(ngModel)]="cardData.reimbursementFuneralBenefit"
             name="reimbursementFuneralBenefit"
             #reimbursementFuneralBenefit="ngModel"
             id="ReembolsoDespesasFuneral"
             disabled
             (change)="isReimbursementFuneralBenefitChanged($event.target.checked)"
             [checked]="cardData?.reimbursementFuneralBenefit?.toString()=='true'">
      <label class="form-check-label align-items-center " for="ReembolsoDespesasFuneral">
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.ReimbursementFuneralBenefit' | translate}}
        <span class="text-primary ml-1" aria-label="Tooltip com informação" [ngClass]="isVisibleReimbursementFuneralBenefit ? 'icon-minus' : 'icon-more'" (click)="toggleVisibilityReimbursementFuneralBenefit()"></span>
      </label>
      <div class="pt-2 text-gray-600 mt-2 mb-5" *ngIf="isVisibleReimbursementFuneralBenefit" style="text-align: justify;">
        <br />
        <span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.ReimbursementFuneralBenefitTooltip' | translate}}</span>
      </div>
    </div>
  </div>
</div>

<!--Subsídio de morte -->
<div class="row">
  <div class="col-sm-12 ml-2">
    <div class="form-check mb-4">
      <input class="form-check-input"
             aria-controls="collapseManual"
             type="checkbox"
             [(ngModel)]="cardData.funeralAllowanceBenefit"
             name="funeralAllowanceBenefit"
             #funeralAllowanceBenefit="ngModel"
             id="SubsidioMorte"
             disabled
             (change)="isFuneralAllowanceBenefitChanged($event.target.checked)"
             [checked]="cardData?.funeralAllowanceBenefit?.toString()=='true'">
      <label class="form-check-label align-items-center " for="SubsidioMorte">
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.FuneralAllowanceBenefit' | translate}}
        <span class="text-primary ml-1" aria-label="Tooltip com informação" [ngClass]="isVisibleFuneralAllowanceBenefit ? 'icon-minus' : 'icon-more'" (click)="toggleVisibilityFuneralAllowanceBenefit()"></span>
      </label>
      <div class="pt-2 text-gray-600 mt-2 mb-5" *ngIf="isVisibleFuneralAllowanceBenefit" style="text-align: justify;">
        <br />
        <span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.FuneralAllowanceBenefitTooltip' | translate}}</span>
      </div>
    </div>
  </div>
</div>


<div class="row">
  <!--Recebeu/requeriu subsídio por morte ou reemb. desp. fun. por outro regime de SS?-->
  <!--Ativo se: Sim, se Benefício requerido = SM ou RDF e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="!isBenefitSMorRDF() || isNotStateRLDiferido()">
        <label for="CGAPension" [class.disabled]="!isBenefitSMorRDF()   || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(!isBenefitSMorRDF()   || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.SSReceived' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo?.slice().reverse()"
                 tabindex="0" class="btn btn-toogle"
                 [class.active]="domain.value==cardData?.SSReceived?.toString()" [radioLabel]="SSReceived">
            <input type="radio" [(ngModel)]="cardData.SSReceived"
                   [required]="!(!isBenefitSMorRDF()   || isNotStateRLDiferido())"
                   name="SSReceived" #SSReceived="ngModel" [value]="domain.value">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

  <!--Vivia em comunhão de mesa e habilitação com o falecido?-->
  <!--Activo; Sim, se Benefício requerido = SM ou SO e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="!isBenefitSMorSO() || isNotStateRLDiferido()">
        <label for="CGAPension" [class.disabled]="!isBenefitSMorSO() || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(!isBenefitSMorSO()  || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.LivedWithDeceased' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo?.slice().reverse()" class="btn btn-toogle"
                 [class.active]="domain.value==cardData?.livedWithDeceased?.toString()"
                 [radioLabel]="livedWithDeceased">
            <input type="radio" [(ngModel)]="cardData.livedWithDeceased" name="livedWithDeceased" #livedWithDeceased="ngModel"
                   [value]="domain.value"
                   [required]="!(!isBenefitSMorSO()  || isNotStateRLDiferido())">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

  <!--Valor da despesa de funeral-->
  <!--Activo : Sim, se Benefício requerido = RDF e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="cardData.reimbursementFuneralBenefit?.toString() != 'true' || isNotStateRLDiferido()">
        <label for="CGAPension" [class.disabled]="cardData.reimbursementFuneralBenefit?.toString() != 'true' || isNotStateRLDiferido()">
          <span *ngIf="!(cardData.reimbursementFuneralBenefit?.toString() != 'true' || isNotStateRLDiferido())" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.FuneralExpense' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [(ngModel)]="cardData.funeralExpense" name="funeralExpense"
                 #funeralExpense="ngModel"
                 maxValue="999000"
                 minValue="0"
                 messageFieldType="currency"
                 [required]="!(cardData.reimbursementFuneralBenefit?.toString() != 'true' || isNotStateRLDiferido())">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="funeralExpense"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>
</div>

<!--<div class="row">-->
  <!-- Efetuou descontos para a segurança social? -->
  <!--Activo : Sim, se Benefício requerido = SM ou SO e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <!--<div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="benefitChoosen==BenefitChoosen.ReimbursementFuneral || isNotStateRLDiferido()">
        <label for="SSDiscounts"  [class.disabled]="benefitChoosen==BenefitChoosen.ReimbursementFuneral || isNotStateRLDiferido()">
          <span class="mandatory"  *ngIf="!(benefitChoosen==BenefitChoosen.ReimbursementFuneral  || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.SSDiscounts' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle"
                 [class.active]="domain.value==cardData.SSDiscounts?.toString()" [radioLabel]="SSDiscounts">
            <input type="radio"
                   [(ngModel)]="cardData.SSDiscounts"
                   name="SSDiscounts"
                   #SSDiscounts="ngModel"
                   [value]="domain.value"
                    [required]="!(benefitChoosen==BenefitChoosen.ReimbursementFuneral  || isNotStateRLDiferido())"
                   [clearRelated]="{model : this.cardData , propsToReset : ['beneficiaryNumber']}">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>

    </div>
  </div>

</div>-->

